// extracted by mini-css-extract-plugin
export default {"info":"history_entries_list___info___b335a637","entriesList":"history_entries_list___entriesList___a12df304"};